import { trans } from "@mongez/localization";
import { useNavigate } from "@remix-run/react";
import { MessageCircle } from "lucide-react";
import { PhoneIcon } from "~/design-system/components/icons/social-icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/design-system/components/ui/tooltip";
import { URLS } from "~/shared/urls";

export function ContactUsButton() {
  const navigate = useNavigate();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={() => navigate(URLS.contactUs)}
          className="group bg-white border border-primary-default fixed bottom-24 max-md:bottom-6 max-md:right-6 max-md:left-auto left-6 z-50 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
          aria-label={trans("contactUs")}
        >
          <PhoneIcon className="h-7 w-7 z-10 transition-transform duration-300 group-hover:rotate-12" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="right" sideOffset={10} className="bg-primary-default text-white border-none">
        {trans("contactUs")}
      </TooltipContent>
    </Tooltip>
  );
}
